// Meta Pixel + event tracking met event_id voor deduplicatie met server-side CAPI.
// PIXEL_ID wordt geïnjecteerd via REACT_APP_META_PIXEL_ID env-variabele.

let _initialized = false;

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

/** Genereer een uniek event_id voor Pixel↔CAPI deduplicatie (Meta vereist max 48u match). */
export const newEventId = () => {
    const ts = Date.now().toString(36);
    const rnd = Math.random().toString(36).slice(2, 10);
    return `evt_${ts}_${rnd}`;
};

/** Laad Meta Pixel base code (eenmalig). No-op zonder PIXEL_ID. */
export const initPixel = () => {
    if (_initialized || !PIXEL_ID || typeof window === "undefined") return;
    _initialized = true;

    // Officiële Meta Pixel snippet
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
    }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
};

/** Track een page view (call bij route change in React Router). */
export const trackPageView = () => {
    if (typeof window === "undefined" || !window.fbq) return;
    window.fbq("track", "PageView");
};

/** Track een Lead conversion. eventId moet identiek zijn aan wat backend ontvangt. */
export const trackLead = ({ eventId, value = 0, currency = "EUR", contentName }) => {
    if (typeof window === "undefined" || !window.fbq) return;
    const params = { value, currency };
    if (contentName) params.content_name = contentName;
    window.fbq("track", "Lead", params, { eventID: eventId });
};
